module.exports = {
    rewards: {
        accountImageBanner: 'https://wowdevmediaaae.blob.core.windows.net/content/dpu-desktop-image-1136x328.jpg',
        accountImageBannerMobile: 'https://wowdevmediaaae.blob.core.windows.net/content/dpu-mobile-320x168.jpg',
        accountImageFloat: 'https://wowdevmediaaae.blob.core.windows.net/content/dpu-card-art.png',
        accountTitle: 'Link your card to see your offers, specials & points',
        accountButtonCta: 'Link your Rewards card',
        accountSubtext: 'Not a member?',
        accountSubtextLinkCta: 'Join Rewards',
        accountSubtextLink: 'https://www.woolworthsrewards.com.au/register.html',
        accountErrorText: 'We are unable to link this Rewards card at this time. Please call Customer Hub on 02 9000 8000.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/rewards.js